/* zuber-chip-filter.js */

if (!customElements.get('zuber-chip-filter')) {
    class ZuberChipFilter extends HTMLElement {
      connectedCallback() {
        this._bar     = this.querySelector('[data-zf-bar]');
        this._overlay = this.querySelector('[data-zf-overlay]');
  
        this._onClick  = this._onClick.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onInput  = this._onInput.bind(this);
        this._onKey    = this._onKey.bind(this);
        this._onScroll = this._onScroll.bind(this);
        this._onResize = this.closeAll.bind(this);
  
        this.addEventListener('click',  this._onClick);
        this.addEventListener('change', this._onChange);
        this.addEventListener('input',  this._onInput);
        document.addEventListener('click',   this._onDocClick = this._onDocClick.bind(this));
        document.addEventListener('keydown', this._onKey);
        window.addEventListener('scroll',    this._onScroll, { passive: true });
        window.addEventListener('resize',    this._onResize);
  
        if (this._overlay) {
          this._overlay.addEventListener('click', () => this.closeAll());
        }
      }
  
      disconnectedCallback() {
        document.removeEventListener('click',   this._onDocClick);
        document.removeEventListener('keydown', this._onKey);
        window.removeEventListener('scroll',    this._onScroll);
        window.removeEventListener('resize',    this._onResize);
      }
  
      _positionPanel(chip, panel) {
        const r = chip.getBoundingClientRect();
        const w = 260;
        let l = r.left;
        if (l + w > window.innerWidth - 12) l = r.right - w;
        if (l < 12) l = 12;
        panel.style.top   = `${r.bottom + 6}px`;
        panel.style.left  = `${l}px`;
        panel.style.width = `${w}px`;
      }
  
      closeAll() {
        this.querySelectorAll('.zf-panel.is-open').forEach(p => p.classList.remove('is-open'));
        if (this._bar) {
          this._bar.querySelectorAll('[data-zf-chip]').forEach(c => c.setAttribute('aria-expanded', 'false'));
        }
        if (this._overlay) this._overlay.classList.remove('is-active');
      }
  
      _buildUrl(panel) {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
  
        const pMin = panel.querySelector('[data-zf-price-min]');
        const pMax = panel.querySelector('[data-zf-price-max]');
        if (pMin) pMin.value ? url.searchParams.set(pMin.name, pMin.value) : url.searchParams.delete(pMin.name);
        if (pMax) pMax.value ? url.searchParams.set(pMax.name, pMax.value) : url.searchParams.delete(pMax.name);
  
        const cbs = panel.querySelectorAll('[data-zf-cb]');
        if (cbs.length) {
          url.searchParams.delete(cbs[0].name);
          cbs.forEach(cb => { if (cb.checked) url.searchParams.append(cb.name, cb.value); });
        }
  
        return url.toString();
      }
  
      _onClick(e) {
        /* 1. Uygula */
        const applyBtn = e.target.closest('[data-zf-apply]');
        if (applyBtn) {
          const panel = applyBtn.closest('.zf-panel');
          if (!panel) return;
          const href = this._buildUrl(panel);
          this.closeAll();
          window.location.href = href;
          return;
        }
  
        /* 2. Temizle */
        const clearBtn = e.target.closest('[data-zf-clear]');
        if (clearBtn) {
          const panel = clearBtn.closest('.zf-panel');
          if (!panel) return;
          const url = new URL(window.location.href);
          url.searchParams.delete('page');
          panel.querySelectorAll('input[name]').forEach(i => url.searchParams.delete(i.name));
          this.closeAll();
          window.location.href = url.toString();
          return;
        }
  
        /* 3. Chip toggle */
        const chip = e.target.closest('[data-zf-chip]');
        if (chip) {
          e.stopPropagation();
          const key   = chip.dataset.zfChip;
          const panel = this.querySelector(`[data-zf-panel="${key}"]`);
          if (!panel) return;
  
          const isOpen = panel.classList.contains('is-open');
          this.closeAll();
  
          if (!isOpen) {
            panel.classList.add('is-open');
            chip.setAttribute('aria-expanded', 'true');
            this._positionPanel(chip, panel);
            if (this._overlay) this._overlay.classList.add('is-active');
            const s = panel.querySelector('[data-zf-search]');
            if (s) setTimeout(() => s.focus(), 40);
          }
          return;
        }
  
        /* 4. Panel içi diğer tıklamalar — kapanmasın */
        if (e.target.closest('.zf-panel')) return;
      }
  
      _onDocClick(e) {
        if (!this.contains(e.target)) this.closeAll();
      }
  
      _onChange(e) {
        /* Sort — anında uygula */
        if (e.target.matches('[data-zf-sort]')) {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', e.target.value);
          url.searchParams.delete('page');
          this.closeAll();
          window.location.href = url.toString();
          return;
        }
  
        /* Checkbox — visual toggle + anında uygula */
        if (e.target.matches('[data-zf-cb]')) {
          const lbl = e.target.closest('.zf-panel__check');
          if (lbl) lbl.classList.toggle('zf-panel__check--on', e.target.checked);
  
          const panel = e.target.closest('.zf-panel');
          if (panel) {
            const href = this._buildUrl(panel);
            this.closeAll();
            window.location.href = href;
          }
          return;
        }
      }
  
      _onInput(e) {
        if (!e.target.matches('[data-zf-search]')) return;
        const q    = e.target.value.toLowerCase();
        const list = e.target.closest('.zf-panel')?.querySelector('[data-zf-list]');
        if (!list) return;
        list.querySelectorAll('.zf-panel__check').forEach(item => {
          const lbl = item.querySelector('.zf-panel__check-label');
          item.toggleAttribute('data-hidden', lbl ? !lbl.textContent.toLowerCase().includes(q) : false);
        });
      }
  
      _onKey(e) {
        if (e.key === 'Escape') this.closeAll();
      }
  
      _onScroll() {
        const open = this.querySelector('.zf-panel.is-open');
        if (!open || !this._bar) return;
        const chip = this._bar.querySelector(`[data-zf-chip="${open.dataset.zfPanel}"]`);
        if (chip) this._positionPanel(chip, open);
      }
    }
  
    customElements.define('zuber-chip-filter', ZuberChipFilter);
  }